import { oc } from '@orpc/contract';
import { listCostItemsOutputSchema, waiveCostItemInputSchema } from '../schemas/costs.schemas.js';
/**
 * Waiving resolves the item to **zero** while keeping the row and its history, which is why it is an
 * administrator's decision and carries a reason (plan §5.5, §6).
 */
export const waiveCostItemContract = oc
    .route({
    method: 'POST',
    path: '/costs/{id}/waive',
    tags: ['Costs'],
    summary: 'Waive a cost item (administrator)',
})
    .input(waiveCostItemInputSchema)
    .output(listCostItemsOutputSchema);
//# sourceMappingURL=waive-cost-item.contract.js.map